import React, { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import ChunkLoadingPopover from '../../UserWidgets/_partials/ChunkLoadingPopover';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../UserWidgets/_partials/WidgetBox';
import reduxConnectContainer from './GroupAbout.container';
import { default as GroupAbout, Props as WidgetProps } from './GroupAbout';

const EditPopup = lazy(
  () => import(/* webpackChunkName: "owner" */ './EditPopup')
);

const GroupAboutBox: React.FC<WidgetProps & WidgetBoxProps> = ({
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  section,
  zone,
  ...props
}) => {
  const { t } = useTranslation();
  const renderConfigPopup = close => {
    const { moduleId } = props;
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <EditPopup moduleId={moduleId} onRequestClose={close} />
      </Suspense>
    );
  };

  return (
    <WidgetBox
      section={section}
      zone={zone}
      moduleId={props.moduleId}
      header={props.title || t('widgets.group_about.header')}
      autoShowWidgetConfig={true}
      widgetMenuRenderer={renderConfigPopup}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
    >
      <GroupAbout {...props} />
    </WidgetBox>
  );
};

export default reduxConnectContainer(GroupAboutBox);
